import { selectableAssets } from '../manual_quality_video/selectable_assets.ts';
import { adaptiveAsset } from '../hls_video/hls_assets.js';

export const selectable = (nativeHlsVideo) => {
  const result = selectableAssets(nativeHlsVideo.allAssets, {
    hdr: nativeHlsVideo.attributes.allowHdr,
  });
  result.unshift(adaptiveAsset(nativeHlsVideo));

  // Assets without max_bitrate are filtered out from our HLS manifest generation on VMA
  // They need to removed from manual quality selection as well in Safari.
  return result.filter((asset) => asset.metadata?.max_bitrate || asset.display_name === 'Auto');
};
